module.exports = __webpack_public_path__ + "img/2GOLDAPPLE.b5c494fb.png";